var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delta-score",class:{
    last: _vm.last,
  }},[_c('Delta',{attrs:{"value":_vm.delta}}),_c('div',{staticClass:"delta-score-content"},[_c('Graph',{attrs:{"overall-value":_vm.safeOverallValue,"project-value":_vm.safeProjectValue,"is-percentage":_vm.isPercentage}})],1),_c('div',{staticClass:"delta-title"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }